(self["webpackChunk_dhl_account_app"] = self["webpackChunk_dhl_account_app"] || []).push([[360],{

/***/ 90360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/en-BE.76533.json";

/***/ })

}])